import { createAction, props, union } from '@ngrx/store';
import { CONVERSATIONAL_PREFIX } from '../constants';
import { ContextExchange, ContextItem, ConversationResponse, ExchangeItem } from './conversational.models';

const loadHistoryContexts = createAction(`${CONVERSATIONAL_PREFIX} Load History Contexts`);
const loadHistoryContextsSuccess = createAction(`${loadHistoryContexts.type} Success`, props<{ contexts: { [contextId: string]: ContextItem } }>());
const loadHistoryContextsFailure = createAction(`${loadHistoryContexts.type} Failure`, props<{ error: Error }>());

const loadContextExchanges = createAction(`${CONVERSATIONAL_PREFIX} Load Context`, props<{ contextId: string }>());
const loadContextExchangesSuccess = createAction(`${loadContextExchanges.type} Success`, props<{ contextId: string; exchanges: Array<ExchangeItem> }>());
const loadContextExchangesFailure = createAction(`${loadContextExchanges.type} Failure`, props<{ contextId: string; error: Error }>());

const deleteContexts = createAction(`${CONVERSATIONAL_PREFIX} Delete Context`, props<{ contextIds: Array<string> }>());
const deleteContextsSuccess = createAction(`${deleteContexts.type} Success`, props<{ contextIds: Array<string> }>());
const deleteContextsFailure = createAction(`${deleteContexts.type} Failure`, props<{ contextIds: Array<string>; error: Error }>());

const addExchange = createAction(`${CONVERSATIONAL_PREFIX} Add Exchange`, props<{ exchange: ExchangeItem }>());
const updateExchange = createAction(`${CONVERSATIONAL_PREFIX} Update Exchange`, props<{ contextId: string; exchangeId: string; exchange: Partial<ExchangeItem | ContextExchange> }>());

const setActiveContext = createAction(`${CONVERSATIONAL_PREFIX} Set Active Context`, props<{ contextId: string | null }>());
const setActiveContextSuccess = createAction(`${setActiveContext.type} Success`);

const hideContextActions = createAction(`${CONVERSATIONAL_PREFIX} Hide Context Actions`, props<{ contextId: string }>());
const updateContextID = createAction(`${CONVERSATIONAL_PREFIX} Update Context ID`, props<{ contextId: string; newContextId: string }>());

const sendCreateElement = createAction(`${CONVERSATIONAL_PREFIX} Send Create Element`, props<{ newExchange: ExchangeItem }>());
const sendCreateElementSuccess = createAction(`${sendCreateElement.type} Success`, props<{ newExchange: ExchangeItem; response: ConversationResponse }>());
const sendCreateElementFailure = createAction(`${sendCreateElement.type} Failure`, props<{ newExchange: ExchangeItem; error: Error }>());

const sendPrompt = createAction(`${CONVERSATIONAL_PREFIX} Send Prompt`, props<{ userExchange: ExchangeItem }>());
const sendPromptSuccess = createAction(`${sendPrompt.type} Success`, props<{ userExchange: ExchangeItem; response: ConversationResponse }>());
const sendPromptFailure = createAction(`${sendPrompt.type} Failure`, props<{ userExchange: ExchangeItem; error: Error }>());

const createListener = createAction(`${CONVERSATIONAL_PREFIX} Create Listener`, props<{ contextId: string; requestId?: string }>());

const sendExchange = createAction(`${CONVERSATIONAL_PREFIX} Send Exchange`, props<{ contextId: string, outputExchangeId: string, exchange: ContextExchange }>());
const sendExchangeSuccess = createAction(`${sendExchange.type} Success`, props<{ contextId: string, exchange: ContextExchange, response: { contextId: string, exchangeId: string }}>());
const sendExchangeFailure = createAction(`${sendExchange.type} Failure`, props<{ contextId: string, outputExchangeId: string, exchange: ContextExchange; error: Error }>());

const updateContextExchange = createAction(`${CONVERSATIONAL_PREFIX} Update Context Exchange`, props<{ contextId: string, exchange: ContextExchange}>());

const setRadarCommand = createAction(`${CONVERSATIONAL_PREFIX} Set an action command for radar`, props<{ action: string, value: string }>());

const all = union({
  loadHistoryContexts,
  loadHistoryContextsSuccess,
  loadHistoryContextsFailure,

  loadContextExchanges,
  loadContextExchangesSuccess,
  loadContextExchangesFailure,

  deleteContexts,
  deleteContextsSuccess,
  deleteContextsFailure,

  addExchange,
  updateExchange,

  setActiveContext,
  setActiveContextSuccess,

  hideContextActions,

  updateContextID,

  sendCreateElement,
  sendCreateElementSuccess,
  sendCreateElementFailure,

  sendPrompt,
  sendPromptSuccess,
  sendPromptFailure,
  
  createListener,

  sendExchange,
  sendExchangeSuccess,
  sendExchangeFailure,

  updateContextExchange,

  setRadarCommand
});

export type ConversationalActionTypes = typeof all;

export const ConversationalActions = {
  loadHistoryContexts,
  loadHistoryContextsSuccess,
  loadHistoryContextsFailure,

  loadContextExchanges,
  loadContextExchangesSuccess,
  loadContextExchangesFailure,

  deleteContexts,
  deleteContextsSuccess,
  deleteContextsFailure,

  addExchange,
  updateExchange,

  setActiveContext,
  setActiveContextSuccess,

  hideContextActions,

  updateContextID,

  sendCreateElement,
  sendCreateElementSuccess,
  sendCreateElementFailure,

  sendPrompt,
  sendPromptSuccess,
  sendPromptFailure,
  
  createListener,

  sendExchange,
  sendExchangeSuccess,
  sendExchangeFailure,

  updateContextExchange,

  setRadarCommand
};
